<template>
  <v-card>
    <v-toolbar dense color="grey lighten-3" flat>
      <v-icon v-if="newDocNoSeq">mdi-plus</v-icon>
      <v-icon v-else>mdi-pencil</v-icon>
      <v-toolbar-title>{{ header }}</v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text>
      <message :messages="messages"></message>
      <form>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs6 v-if="newDocNoSeq">
              <v-autocomplete
                :items="docTypeList"
                v-model="docNoSeqForm.docType"
                :label="labels.docType"
                item-text="label"
                item-value="value"
                data-vv-name="docType"
                :data-vv-as="labels.docType"
                :error-messages="errors.collect('docType')"
                v-validate="'required'"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.docType }}</v-subheader>
              <div class="queryValue">{{ getDesc('docType', docNoSeqForm.docType) }}</div>
            </v-flex>
            <v-flex xs6 v-if="newDocNoSeq">
              <v-autocomplete
                :items="formIdList"
                v-model="docNoSeqForm.formId"
                :label="labels.formId"
                item-text="label"
                item-value="value"
                data-vv-name="formId"
                :data-vv-as="labels.formId"
                :error-messages="errors.collect('formId')"
                v-validate="'required'"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.formId }}</v-subheader>
              <div class="queryValue">{{ getDesc('formId', docNoSeqForm.formId) }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 v-if="newDocNoSeq">
              <v-text-field
                v-model="docNoSeqForm.keyFact1"
                :label="labels.keyFact1"
                :error-messages="errors.collect('keyFact1')"
                data-vv-scope="filter"
                data-vv-name="keyFact1"
                :data-vv-as="labels.keyFact1"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.keyFact1 }}</v-subheader>
              <div class="queryValue">{{ checkEmpty(docNoSeqForm.keyFact1) }}</div>
            </v-flex>
            <v-flex xs6 v-if="newDocNoSeq">
              <v-text-field
                v-model="docNoSeqForm.keyFact2"
                :label="labels.keyFact2"
                :error-messages="errors.collect('keyFact2')"
                data-vv-scope="filter"
                data-vv-name="keyFact2"
                :data-vv-as="labels.keyFact2"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.keyFact2 }}</v-subheader>
              <div class="queryValue">{{ checkEmpty(docNoSeqForm.keyFact2) }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 v-if="newDocNoSeq">
              <v-text-field
                v-model="docNoSeqForm.keyFact3"
                :label="labels.keyFact3"
                :error-messages="errors.collect('keyFact3')"
                data-vv-scope="filter"
                data-vv-name="keyFact3"
                :data-vv-as="labels.keyFact3"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.keyFact3 }}</v-subheader>
              <div class="queryValue">{{ checkEmpty(docNoSeqForm.keyFact3) }}</div>
            </v-flex>
            <v-flex xs6 v-if="newDocNoSeq">
              <v-text-field
                v-model="docNoSeqForm.keyFact4"
                :label="labels.keyFact4"
                :error-messages="errors.collect('keyFact4')"
                data-vv-scope="filter"
                data-vv-name="keyFact4"
                :data-vv-as="labels.keyFact4"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.keyFact4 }}</v-subheader>
              <div class="queryValue">{{ checkEmpty(docNoSeqForm.keyFact4) }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 v-if="newDocNoSeq">
              <v-text-field
                v-model="docNoSeqForm.keyFact5"
                :label="labels.keyFact5"
                :error-messages="errors.collect('keyFact5')"
                data-vv-scope="filter"
                data-vv-name="keyFact5"
                :data-vv-as="labels.keyFact5"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.keyFact5 }}</v-subheader>
              <div class="queryValue">{{ checkEmpty(docNoSeqForm.keyFact5) }}</div>
            </v-flex>
            <v-flex xs6 v-if="newDocNoSeq">
              <v-text-field
                v-model="docNoSeqForm.keyFact6"
                :label="labels.keyFact6"
                :error-messages="errors.collect('keyFact6')"
                data-vv-scope="filter"
                data-vv-name="keyFact6"
                :data-vv-as="labels.keyFact6"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{ labels.keyFact6 }}</v-subheader>
              <div class="queryValue">{{ checkEmpty(docNoSeqForm.keyFact6) }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 v-if="!queryDocNoSeq">
              <v-text-field
                v-model="docNoSeqForm.nxtSeqNo"
                type="number"
                :label="labels.nxtSeqNo"
                :error-messages="errors.collect('nxtSeqNo')"
                data-vv-name="nxtSeqNo"
                :data-vv-as="labels.nxtSeqNo"
                v-validate="'required|numeric'"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="queryDocNoSeq">
              <v-subheader class="queryLabel">{{ labels.nxtSeqNo }}</v-subheader>
              <div class="queryValue">{{ docNoSeqForm.nxtSeqNo }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ docNoSeqForm.createdName }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ formatDisplayDate(docNoSeqForm.createdDate) }}</div>
            </v-flex>
            <v-flex xs6 v-if="!newDocNoSeq">
              <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              <div class="queryValue">{{ docNoSeqForm.modifiedName }}</div>
            </v-flex>
            <v-flex xs6 v-if="!newDocNoSeq">
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ formatDisplayDate(docNoSeqForm.modifiedDate) }}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" text @click.native="close">Cancel</v-btn>
      <v-btn v-if="!queryDocNoSeq" color="primary" text @click.native="doSave">{{ newDocNoSeq ? 'Save' : 'Update' }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
// import { expandURI } from '@/utils/ajax'

export default {
  props: {
    docNoSeqForm: Object,
    mode: String
  },
  data() {
    return {
      labels: {
        docType: 'Document Type',
        formId: 'Format ID',
        keyFact1: 'Key Factor 1 Type',
        keyFact2: 'Key Factor 2 Type',
        keyFact3: 'Key Factor 3 Type',
        keyFact4: 'Key Factor 4 Type',
        keyFact5: 'Key Factor 5 Type',
        keyFact6: 'Key Factor 6 Type',
        nxtSeqNo: 'Next Seq No.',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      newDocNoSeq: false,
      queryDocNoSeq: false,
      header: '',
      today: new Date(),
      loading: false,
      submitting: false
    }
  },
  watch: {
    mode: function (value) {
      this.doInit()
    }
  },
  computed: {
    menu() {
      return this.$store.state.docFormatParam.menu
    },
    docTypeList() {
      return [
        { label: 'C - Claim No.', value: 'C' },
        { label: 'P - Policy No.', value: 'P' },
        { label: 'V - Voyage No.', value: 'V' },
        { label: 'H - Vessel No.', value: 'H' }
      ]
    },
    formIdList() {
      return [
        { label: '01', value: 1 },
        { label: '02', value: 2 },
        { label: '03', value: 3 },
        { label: '04', value: 4 },
        { label: '05', value: 5 },
        { label: '06', value: 6 },
        { label: '07', value: 7 },
        { label: '08', value: 8 },
        { label: '09', value: 9 },
        { label: '10', value: 10 }
      ]
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      if (this.mode === 'edit') {
        this.header = 'Review Doc No. Sequence'
        this.newDocNoSeq = false
        this.queryDocNoSeq = false
      } else {
        this.newDocNoSeq = false
        this.queryDocNoSeq = true
        this.header = 'Query Doc No. Sequence'
      }
    },
    doInitForm() {
      this.resetValidator()
      this.resetMessages()
      this.docNoSeqForm.docType = null
      this.docNoSeqForm.formId = null
      this.docNoSeqForm.keyFact1 = null
      this.docNoSeqForm.keyFact2 = null
      this.docNoSeqForm.keyFact3 = null
      this.docNoSeqForm.keyFact4 = null
      this.docNoSeqForm.keyFact5 = null
      this.docNoSeqForm.keyFact6 = null
      this.docNoSeqForm.nxtSeqNo = null
      this.docNoSeqForm.createdName = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.docNoSeqForm.createdDate = new Date()
    },
    formatDisplayDate(xDate) {
      if (xDate) {
        return formatDisplayDate(xDate)
      } else {
        return undefined
      }
    },
    getDesc(field, id) {
      var list = []
      if (field === 'docType') {
        list = this.docTypeList
      } else {
        list = this.formIdList
      }
      if (id) {
        for (var i in list) {
          if (id === list[i].value) {
            return list[i].label
          }
        }
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newDocNoSeq) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    checkEmpty(field) {
      if (field === '') {
        return '-'
      } else {
        return field
      }
    },
    async doCreate() {
      const apiURI = this.menu.createDocNoSeq
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.docNoSeqForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.close()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateDocNoSeq
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.docNoSeqForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.close()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    close() {
      this.doInitForm()
      this.$emit('close')
    }
  },
  created() {
    this.doInit()
  },
  mixins: [MessageMixin]
}
</script>
